<script lang="ts">

    /* IMPORTS -------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Button,
        Heading,
        Paragraph,
        SubscriptionList,
        UnsubscribedModal,
    } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import LayoutInside from 'src/app/library/layouts/layout-inside/LayoutInside.svelte';
    import SubscriptionsTable from './components/SubscriptionList.svelte';

</script>

<LayoutInside>
    <svelte:fragment slot = 'main'>
        <div class = 's8-page-wrapper'>
            <div class = 's8-page-header'>
                <Heading size = 'lg'>Subscriptions</Heading>
                <Button
                    icon = 'plus'
                    align = 'left'
                    label = 'Create New Subscription'
                    url = '/subscriptions/create'
                />
            </div>

            <SubscriptionList
                parameters = { { states: [ 'created', 'paused' ] } }
                let:subscriptions
            >

                <div class = 's8-paragraph'>
                    <Paragraph
                        label =
                            'The following are all the subscriptions that you currently get email notifications for:'
                        size = 'lg'
                    />
                </div>

                <SubscriptionsTable { subscriptions } />

                <svelte:fragment slot = 'empty'>
                    <!-- eslint-disable max-len -->
                    <Paragraph
                        label = 'You do not get notified for anything yet, click on the Create New Subscription button above to start.'
                        size = 'md'
                    />
                    <!-- eslint-enable -->
                </svelte:fragment>
            </SubscriptionList>
        </div>
    </svelte:fragment>
</LayoutInside>
<UnsubscribedModal />

<style lang="postcss">
    div.s8-page-wrapper {
        padding-bottom: 15px;
    }

    div.s8-page-header {
        display: flex;
        justify-content: space-between;
    }

    div.s8-paragraph {
        margin-bottom: 20px;
    }
</style>